import React, { useState } from 'react'
import { Container, Label, Divisor } from './styles'
import { message } from '~/services'
import { useCheckUp } from '~/context'
import { RadioButtons } from '~/components/shared'
import { ECheckUpSensitivityParams, ECheckUpSimulationParams, IFetchCheckUpPropertiesParams } from '~/interfaces'
import { defaultCheckUpRequestParams, sensitivityFilterOptions, simulationFilterOptions } from '~/constants/checkUp'
import { Inline } from '~/styles'

const debounceDelay = 700
let debounceTimer: ReturnType<typeof setTimeout> | null = null

export const CheckUpFilters = (): JSX.Element => {
  const { isLoadingCheckUp, updateCheckUpPropertiesFilters } = useCheckUp()

  const [sensitivityFilterValue, setSensitivityFilterValue] = useState<ECheckUpSensitivityParams>(
    defaultCheckUpRequestParams.sensitivity
  )
  const [simulationFilterValue, setSimulationFilterValue] = useState<ECheckUpSimulationParams>(
    defaultCheckUpRequestParams.simulation
  )

  const updateRequestFilters = (newFilters: IFetchCheckUpPropertiesParams['queryParams']): void => {
    if (debounceTimer) clearTimeout(debounceTimer)

    debounceTimer = setTimeout(() => {
      updateCheckUpPropertiesFilters(newFilters)
    }, debounceDelay)
  }

  const handleSensitivityFilter = (value: ECheckUpSensitivityParams): void => {
    updateRequestFilters({ sensitivity: value, simulation: simulationFilterValue })
    setSensitivityFilterValue(value)
  }

  const handleSimulationFilter = (value: ECheckUpSimulationParams): void => {
    updateRequestFilters({ sensitivity: sensitivityFilterValue, simulation: value })
    setSimulationFilterValue(value)
  }

  return (
    <Container>
      <Inline spacing="0.5rem" justifyContent="center">
        <Label>{message('analyticalModels.desired_sensitivity')}</Label>
        <RadioButtons
          value={sensitivityFilterValue}
          options={sensitivityFilterOptions}
          onChange={value => handleSensitivityFilter(value as ECheckUpSensitivityParams)}
          propertyToBeReturned="value"
          isDisabled={isLoadingCheckUp}
        />
      </Inline>

      <Divisor />

      <Inline spacing="0.5rem" justifyContent="center">
        <Label>{message('analyticalModels.simulate')}</Label>
        <RadioButtons
          value={simulationFilterValue}
          options={simulationFilterOptions}
          onChange={value => handleSimulationFilter(value as ECheckUpSimulationParams)}
          propertyToBeReturned="value"
          isDisabled={isLoadingCheckUp}
        />
      </Inline>
    </Container>
  )
}
